<template>
  <div>
    <v-card class="mx-auto" flat>
      <v-card-text>
        <h2 class="mb-3">
          Silakan lengkapi isian data berikut
        </h2>
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="3" v-if="false">
            <div><span class="indigo--text">Pilih sumber data</span></div>
            <v-radio-group v-model="sumber" row dense hide-details class="pa-0 ma-0" @change="onChange">
              <v-radio v-for="(item, i) in mSumber" :value="item.value" :key="i" :label="item.text" />
            </v-radio-group>
          </v-col>
          <v-col cols="12" sm="12" md="9">
            <template v-if="!detail || (detail && !$isObject(detail))">
              <div><span class="indigo--text">Pilih Sekolah</span></div>
              <v-btn dark color="secondary" left @click="onSelect">
                <v-icon left>mdi-home</v-icon> Pilih Sekolah
              </v-btn>
            </template>
          </v-col>
        </v-row>
        <div v-if="detail && $isObject(detail)">
          <v-divider class="my-3" v-if="false" />
          <div><span class="indigo--text">Sekolah yang dipilih</span></div>
          <v-list-item class="px-0 mb-3">
            <v-list-item-avatar color="secondary lighten-3" size="50">
              <v-icon dark style="font-size: 30px">mdi-home</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0">
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <h2 class="body-1 secondary--text">{{ $getDeepObj(detail, 'nama') || '-' }}</h2>
                  <div style="line-height: 1.2">
                    <label class="grey--text">Jenjang: </label>
                    {{ $getDeepObj(detail, 'm_jenjang.data.singkat') || '-' }}
                  </div>
                  <div style="line-height: 1.2">
                    <label class="grey--text">{{ detail.k_kota ? 'Kota' : 'Provinsi' }}: </label>
                    {{
                      $getDeepObj(detail, 'm_kota.data.keterangan') ||
                        $getDeepObj(detail, 'm_propinsi.data.keterangan') ||
                        '-'
                    }}
                  </div>
                </v-col>
                <v-col cols="12" md="8">
                  <v-btn dark color="secondary" left @click="onSelect">
                    <v-icon left>mdi-pencil</v-icon> Ganti Sekolah
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <div><span class="indigo--text">Kepala Sekolah</span></div>
          <div>
            <template>
              <v-list-item class="px-0 mb-3">
                <v-list-item-avatar color="secondary lighten-3" size="50">
                  <v-icon dark style="font-size: 30px">mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <h2 class="body-1 secondary--text">
                        {{ $getDeepObj(kasek, 'nama') || '-' }}
                      </h2>
                      <div style="line-height: 1.2">
                        <label class="grey--text">No. UKG/SIMPKB ID:: </label>
                        {{ $getDeepObj(kasek, 'no_ukg') || '-' }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="8">
                      <span class="black--text" style="font-size: 16px">
                        Pindahkan Kepala Sekolah ke <strong>Kelompok B</strong> ?
                      </span>
                      <v-radio-group v-model="ganti_kasek" row dense class="mt-0">
                        <v-radio :value="1">
                          <template v-slot:label>
                            <span class="black--text">
                              <strong class="mr-1">Ya,</strong>
                              <span class="warning--text text--darken-1">Pindahkan</span>
                            </span>
                          </template>
                        </v-radio>
                        <v-radio :value="0">
                          <template v-slot:label>
                            <span class="black--text">
                              <strong class="mr-1">Tidak,</strong>
                              <span class="secondary--text">Tetap kelompok A</span>
                            </span>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </template>
          </div>
          <div><span class="indigo--text">Pengawas Sekolah yang dipilih</span></div>
          <div>
            <template v-if="(pengawas && $isObject(pengawas)) || (pengawasBaru && $isObject(pengawasBaru))">
              <v-list-item class="px-0 mb-3">
                <v-list-item-avatar color="secondary lighten-3" size="50">
                  <v-icon dark style="font-size: 30px">mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <h2 class="body-1 secondary--text">{{
                        $getDeepObj(pengawasBaru, 'ptk.data.nama') || $getDeepObj(pengawas, 'nama') || '-'
                      }}</h2>
                      <div style="line-height: 1.2">
                        <label class="grey--text">No. UKG/SIMPKB ID:: </label>
                        {{
                          $getDeepObj(pengawasBaru, 'no_ukg') ||
                            $getDeepObj(pengawasBaru, 'ptk_id') ||
                            $getDeepObj(pengawas, 'ptk.data.no_ukg') ||
                            $getDeepObj(pengawas, 'ptk_id') ||
                            ''
                        }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-btn dark color="secondary" left @click="onSelectPengawas">
                        <v-icon left>mdi-pencil</v-icon> Ganti Pengawas
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-else>
              <v-btn dark color="secondary" left @click="onSelectPengawas">
                <v-icon left>mdi-account</v-icon> Pilih Pengawas
              </v-btn>
            </template>
          </div>
          <template v-if="$getDeepObj(peserta, 'data').length">
            <div class="mt-5"><span class="indigo--text">Peserta di Kelompok A</span></div>
            <v-alert border="left" colored-border color="indigo" dense style="background-color: #E8EAF6" class="mb-1">
              Pilih Peserta yang ingin <strong>diganti / mengundurkan diri di Kelompok A</strong> (jika ada)
            </v-alert>
            <v-row no-gutters>
              <template v-for="(p, key) in $getDeepObj(peserta, 'data')">
                <v-col cols="12" sm="12" md="6" :key="key" v-if="key % 2 === 0">
                  <v-checkbox
                    v-model="ganti"
                    color="blue"
                    :value="$getDeepObj(p, 'ptk_id')"
                    hide-details
                    class="pa-0 mt-1"
                    dense
                  >
                    <template v-slot:label>
                      <v-row no-gutters class="my-2">
                        <v-col cols="12">
                          <span class="font-weight-bold black--text">{{ $getDeepObj(p, 'ptk.data.nama') }}</span>
                        </v-col>
                        <v-col cols="12" md="4">
                          <div class="caption">
                            <v-icon small left>mdi-card-account-details-outline</v-icon>
                            {{ $getDeepObj(p, 'ptk.data.no_ukg') || '-' }}
                            <br />
                            <v-icon small left>mdi-home-variant</v-icon>
                            {{ $isObject($getDeepObj(p, 'ptk.data.ptk_sekolah')) ? 'Satminkal' : 'Non Satminkal' }}
                            -
                            {{ $getDeepObj(p, 'ptk.data.m_pegawai.data.is_pns') ? 'PNS' : 'NON PNS' }}
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="caption">
                            <v-icon small left>mdi-book</v-icon>
                            {{ $getDeepObj(p, 'm_mapel_psp.data.keterangan') }}
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="12" sm="12" md="6" :key="key" v-else>
                  <v-checkbox
                    v-model="ganti"
                    color="blue"
                    :value="$getDeepObj(p, 'ptk_id')"
                    hide-details
                    class="pa-0 mt-1"
                    dense
                  >
                    <template v-slot:label>
                      <v-row no-gutters class="my-2">
                        <v-col cols="12">
                          <span class="font-weight-bold black--text">{{ $getDeepObj(p, 'ptk.data.nama') }}</span>
                        </v-col>
                        <v-col cols="12" md="4">
                          <div class="caption">
                            <v-icon small left>mdi-card-account-details-outline</v-icon>
                            {{ $getDeepObj(p, 'ptk.data.no_ukg') || '-' }}
                            <br />
                            <v-icon small left>mdi-home-variant</v-icon>
                            {{ $isObject($getDeepObj(p, 'ptk.data.ptk_sekolah')) ? 'Satminkal' : 'Non Satminkal' }}
                            -
                            {{ $getDeepObj(p, 'ptk.data.m_pegawai.data.is_pns') ? 'PNS' : 'NON PNS' }}
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="caption">
                            <v-icon small left>mdi-book</v-icon>
                            {{ $getDeepObj(p, 'm_mapel_psp.data.keterangan') }}
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-checkbox>
                </v-col>
              </template>
            </v-row>
          </template>
          <template v-if="guru.length">
            <div class="mt-5"><span class="indigo--text">Peserta di Kelompok B</span></div>
            <v-alert border="left" colored-border color="indigo" dense style="background-color: #E8EAF6" class="mb-1">
              Pilih Peserta yang ingin <strong>ditambahkan di Kelompok B</strong> (jika ada)
            </v-alert>
            <template v-for="(f, i) in items">
              <v-list-item :key="i" class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" md="4">
                      <validation-provider name="Pilih Mapel" rules="required" v-slot="{ errors }">
                        <v-autocomplete
                          label="Pilih Mapel"
                          :items="i === 0 ? options.mapel : filteredOptions.mapel"
                          item-text="keterangan"
                          item-value="k_mapel_psp"
                          item-disabled="disabled"
                          v-model="form[i]['k_mapel_psp']"
                          outlined
                          single-line
                          dense
                          hide-details
                          :error-messages="errors"
                        ></v-autocomplete>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-row no-gutters>
                        <v-col cols="11">
                          <validation-provider name="Pilih Guru" rules="required" v-slot="{ errors }">
                            <v-autocomplete
                              label="Pilih Guru"
                              :items="i === 0 ? options.guru : filteredOptions.guru"
                              item-text="nama"
                              item-value="ptk_id"
                              item-disabled="disabled"
                              v-model="form[i]['ptk_id']"
                              outlined
                              single-line
                              dense
                              hide-details
                              :error-messages="errors"
                            >
                              <template v-slot:selection="data">
                                <v-list-item-content style="width: 100% !important;">
                                  <h2 class="subtitle-1">{{ $getDeepObj(data, 'item.nama') || '-' }}</h2>
                                  <p class="caption mb-0">
                                    <span>
                                      <v-icon small left>mdi-card-account-details-outline</v-icon>
                                      {{ $getDeepObj(data, 'item.no_ukg') || '-' }}
                                      <br />
                                      <v-icon small left>mdi-home-variant</v-icon>
                                      {{ $getDeepObj(data, 'item.satminkal') || '-' }}
                                      -
                                      {{ $getDeepObj(data, 'item.status') || '-' }}
                                    </span>
                                  </p>
                                </v-list-item-content>
                              </template>
                              <template v-slot:item="data">
                                <v-list-item-content class="full-width">
                                  <h2 class="subtitle-1">{{ $getDeepObj(data, 'item.nama') || '-' }}</h2>
                                  <p class="caption">
                                    <span>
                                      <v-icon small left>mdi-card-account-details-outline</v-icon>
                                      {{ $getDeepObj(data, 'item.no_ukg') || '-' }}
                                      <br />
                                      <v-icon small left>mdi-home-variant</v-icon>
                                      {{ $getDeepObj(data, 'item.satminkal') || '-' }}
                                      -
                                      {{ $getDeepObj(data, 'item.status') || '-' }}
                                    </span>
                                  </p>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </validation-provider>
                        </v-col>
                        <v-col cols="1">
                          <v-btn icon color="red" rounded @click="onRemovePeserta(i)">
                            <v-icon>mdi-close-circle</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text> </v-list-item-action-text>
              </v-list-item>
            </template>
            <div>
              <v-btn color="blue" class="white--text" @click="onAddPeserta">
                <v-icon color="white" left>mdi-plus-circle</v-icon> Tambah Peserta
              </v-btn>
            </div>
          </template>
        </div>
      </v-card-text>
    </v-card>
    <Sekolah ref="kandidat" :is-baru="sumber" :masters="masters" />
    <Pengawas ref="pengawas" jenis="kandidat-pengawas" :sekolah-id="detail && detail.sekolah_id" :masters="masters" />
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { mapActions } from 'vuex';

export default {
  components: {
    Sekolah: () => import('../component/Sekolah'),
    Pengawas: () => import('../component/Sumber'),
    ValidationProvider,
  },

  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      sekolah_id: null,
      sumber: 0,
      detail: null,
      kasek: {},
      pengawas: null,
      pengawasBaru: null,
      mSumber: [
        { text: 'Sekolah Baru', value: 1 },
        { text: 'Sekolah di Kelompok A', value: 0 },
      ],
      mapel: [],
      guru: [],
      peserta: [],
      items: [],
      form: [],
      ganti: [],
      ganti_kasek: 0,
      deffForm: {
        k_mapel_psp: [],
        ptk_id: [],
      },
      cards: {
        mapel: {
          nama: 'keterangan',
          icon: 'mdi-book-open-page-variant',
        },
        guru: {
          nama: 'nama',
          icon: 'mdi-account',
        },
      },
    };
  },

  computed: {
    filteredOptions() {
      const mergeMapel = this.form.map((item) => item && item['k_mapel_psp']) || [];
      const mergePeserta = this.form.map((item) => item && item['ptk_id']) || [];

      const grupedMapel = this.mapel.filter((key) => {
        let getKelompok = '';
        if (mergeMapel.length) {
          const mapelIndex = this.mapel.findIndex((s) => s.k_mapel_psp === Number(mergeMapel[0]));
          const mapel = this.mapel[mapelIndex];
          getKelompok = (mapel && mapel.kelompok) || '';
        }
        return (key.kelompok || '') === getKelompok;
      });
      const mapMapel = (mergeMapel.length ? grupedMapel : this.mapel).map((item) => {
        const findIndex = mergeMapel.findIndex((s) => s === Number(item.k_mapel_psp));
        const jmlMapelSama = mergeMapel.filter((m) => m === Number(item.k_mapel_psp)).length;
        return {
          k_mapel_psp: item && item.k_mapel_psp,
          keterangan: item && item.keterangan,
          disabled: findIndex > -1 && jmlMapelSama >= item.maks_guru,
        };
      });

      const mapPeserta = this.guru.map((key) => {
        const findIndex = mergePeserta.findIndex((s) => s === key.ptk_id);
        return {
          ptk_id: key.ptk_id,
          nama: key.nama,
          no_ukg: key.no_ukg || key.ptk_id,
          disabled: findIndex > -1,
          satminkal: this.$isObject(key.ptk_sekolah) ? 'Satminkal' : 'Non Satminkal',
          status: key.m_pegawai && key.m_pegawai.is_pns ? 'PNS' : 'Non PNS',
        };
      });

      return { mapel: mapMapel || [], guru: mapPeserta || [] };
    },

    options() {
      const mapMapel = this.mapel.map((item) => {
        return {
          k_mapel_psp: item && item.k_mapel_psp,
          keterangan: item && item.keterangan,
        };
      });
      const mapPeserta = this.guru.map((item) => {
        return {
          ptk_id: item.ptk_id,
          nama: item.nama,
          no_ukg: item.no_ukg || item.ptk_id,
          satminkal: this.$isObject(item.ptk_sekolah) ? 'Satminkal' : 'Non Satminkal',
          status: item.m_pegawai && item.m_pegawai.is_pns ? 'PNS' : 'Non PNS',
        };
      });

      return { mapel: mapMapel || [], guru: mapPeserta || [] };
    },
  },

  methods: {
    ...mapActions('diklat', ['kandidat']),

    reset() {
      this.$set(this, 'detail', null);
      this.$set(this, 'kasek', {});
      this.$set(this, 'pengawas', null);
      this.$set(this, 'pengawasBaru', null);
      this.$set(this, 'form', []);
      this.$set(this, 'ganti', []);
      this.$set(this, 'ganti_kasek', 0);
      this.sumber = 0;
    },

    onChange() {
      this.sekolah_id = null;
      this.detail = null;
    },

    onSelect() {
      this.$refs.kandidat.open(`Pilih Sekolah ${this.sumber === 1 ? 'Baru' : 'dari Kelompok A'}`).then((item) => {
        this.detail = item;
        this.pengawas = null;
        this.pengawasBaru = null;
        this.sekolah_id = item.sekolah_id || '';

        this.$set(this, 'mapel', []);
        this.$set(this, 'guru', []);
        this.$set(this, 'peserta', []);
        this.$set(this, 'ganti_kasek', 0);

        this.kandidat({ id: this.sekolah_id }).then(({ data, meta }) => {
          this.$set(this, 'form', []);
          this.$set(this, 'ganti', []);
          this.$set(this, 'mapel', meta?.mapel ?? []);
          this.$set(this, 'guru', meta?.guru ?? []);
          this.$set(this, 'kasek', this.$getDeepObj(data, 'ptk_kasek.data') || {});
          this.$set(this, 'pengawas', meta?.pengawas ?? null);
          this.$set(this, 'peserta', data?.psp_diklat_gurus ?? []);
          this.$set(this, 'items', []);
        });
      });
    },

    onSelectPengawas() {
      this.$refs.pengawas.open('Pilih Pengawas').then((pengawas) => {
        this.pengawasBaru = pengawas;
      });
    },

    onAddPeserta() {
      this.items.push({ form: this.deffForm });
      this.form.push({ k_mapel_psp: '', ptk_id: '' });
    },

    onRemovePeserta(i) {
      this.items.splice(i, 1);
      this.form.splice(i, 1);
    },

    getValue() {
      const id = (this.detail && this.detail.sekolah_id) || '';
      const ganti = this.ganti.map((value) => {
        return { ptk_id: value };
      });

      let params = {
        diklat_gurus: this.form,
        ganti: ganti,
        ganti_kasek: this.ganti_kasek,
      };

      if (this.pengawasBaru && this.pengawasBaru.ptk_id !== this.pengawas.ptk_id) {
        params['diklat_pengawas'] = { ptk_id: this.pengawasBaru.ptk_id };
      }

      return { id, params };
    },
  },
};
</script>
